import React, {useState, useEffect, useRef} from "react"
import PropTypes from "prop-types"
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  Table,
  Row,
  Col, Input, Alert,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container, Card, CardBody, CardTitle, CardText
} from "reactstrap"
import Select from "react-select"
import axios from "axios"
import * as url from "../../helpers/url_helper"
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { Link, useHistory, useParams } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import LoadingOverlay from 'react-loading-overlay';
LoadingOverlay.propTypes = undefined
import BounceLoader from 'react-spinners/BounceLoader'
import MetaTags from 'react-meta-tags'; 
import ChantBox from "./chat/ChatBox"
import { MapContainer, TileLayer, Marker, Tooltip, Polyline, LayersControl } from 'react-leaflet';
import rd from "assets/icons/pin2.png";
import L from "leaflet"

const ComplaintDetails = () => {
    const {id} = useParams()
    const history = useHistory();
    toastr.options = TOAST_OPTIONS;


    const [isEdit, setIsEdit] = useState(false);
    const [categories, setCategories] = useState([])

    const [refno, setRefNo] = useState('')
    const [name, setName] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [account, setAccount] = useState('')
    const [address, setAddress] = useState('')
    const [area, setArea] = useState('')
    const [category, setCategory] = useState('')
    const [details, setDetails] = useState('')
    const [status, setStatus] = useState('')
    const [handlerDept, setHandlerDept] = useState('')
    const [assigns, setAssigns] = useState([])
    const [deptList, setDeptList] = useState([])
    const [handler, setHandler] = useState('')
    const [dateTimeAssigned, setDateTimeAssigned] = useState('')
    const [dateTimeRegistered, setDateTimeRegistered] = useState('')
    const [languages, setlanguages] = useState([])
    const [lang, setLang] = useState('Somali')
    const [areas, setAreas] = useState([])

    const [assignedId, setAssignedId]       = useState('')
    const [userId, setUserId]       = useState('')
    const [userName, setUserName]   = useState('')
    const [sameDept, setSameDept]   = useState(false)
    const [userCategory, setUserCategory] = useState('')
    const [nHandlerDept, setNHandlerDept] = useState('')
    const [nHandler, setNHandler] = useState('')

    const [closedOn, setClosedOn] = useState('')
    const [workDone, setWorkDone] = useState('')
    const [recommendations, setRecommendations] = useState('')
    const [responseTime, setResponseTime] = useState('')
    const [correctionTime, setCorrectionTime] = useState('')
    const [totalCorrectionTime, setTotalCorrectionTime] = useState('')

    const [logs, setLogs] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [general, setGeneral] = useState(true)
    const [modal_assign, setmodal_assign] = useState(false)
    const [loadingFiles, setLoadingFiles] = useState(false)
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [modal_file, setmodal_file] = useState(false);
    const [selectedFile, setSelectedFile] = useState([])

    const [center, setCenter] = useState([9.426039, 46.270828])
    const mapRef = useRef(null);
    const [lat, setLat] = useState(null);
    const [lng, setLng] = useState(null);
    const [routeCoordinates, setRouteCoordinates] = useState([]);
    const [distance, setDistance] = useState('Location')

    const removeBodyCss = () => {
        document.body.classList.add("no_padding");
    }
    const fetchRoute = async (latlon) => {
      try {
        const apiKey = process.env.REACT_APP_APIKEY;
        const start = '44.051146,9.560198'; 
        const end = latlon; 
        const urx = `https://api.mapbox.com/directions/v5/mapbox/driving/${start};${end}?alternatives=true&continue_straight=true&geometries=polyline&language=en&overview=full&steps=true&access_token=${apiKey}`;
        let rt = []
        const response = await axios.get(urx);
        const coordinates = response.data.routes[0].geometry.coordinates;
        if(response.data.routes.length > 0){
          setDistance(response.data.routes[0].legs[0].summary +" - "+((response.data.routes[0].legs[0].distance)/1000).toFixed(1) + "km")
          response.data.routes[0].legs[0].steps.map((a)=>{
            if(a.intersections.length > 0){
              a.intersections.map((i)=>{
                rt.push([i.location[1],i.location[0]])
              })
            }
          })
        }
        setRouteCoordinates(rt);
      } catch (error) {
        console.error('Error fetching route:', error);
      }
    };
    const redPoint = L.icon({
      iconUrl:rd,
      iconSize: [26, 51], 
      iconAnchor: [14, 80], 
      popupAnchor: [-3, -76] 
    })
    const tog_assign = () => {
        setmodal_assign(!modal_assign);
        removeBodyCss();
    }
    const tog_file = () => {
      setmodal_file(!modal_file);
      removeBodyCss();
    }
    const handleCheckAcc = (l) => {
      const data = { supplyNo: l }; 
      axios.post(url.GIS, JSON.stringify(data))
        .then((response) => {
          const { data } = response;
          if (data.latitude) {
            const lati = parseFloat(data.longitude)
            const long = parseFloat(data.latitude)
            zoomIn();
            setLat(lati);
            setLng(long);
            setMapCenterAnimated(lati, long);
            fetchRoute(long+','+lati)
          } else {
            zoomOut();
            setLat(null);
            setLng(null);
            setMapCenterAnimated(9.426039, 46.270828);
            toastr.info('Supply number has no GIS data')
          }
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    };
    const zoomIn = () => {
      if (mapRef.current) {
        const map = mapRef.current; 
        const currentZoom = map.getZoom(); 
        map.setZoom(16); 
      }
    };

    const zoomOut = () => {
      if (mapRef.current) {
        const map = mapRef.current; 
        const currentZoom = map.getZoom(); 
        map.setZoom(5); 
      }
    };

    const setMapCenterAnimated = (lat, lng) => {
      setCenter([lat, lng]); 
      if (mapRef.current) {
        mapRef.current.flyTo([lat, lng], mapRef.current.getZoom(), {
          duration: 5, 
          animate: true 
        });
      }
    };
   
    const fetchData = () => {
        handleFilterData()
        axios.get(url.COMPLAINTCATEGORIES, Config).then((r)=>{ 
          setCategories(r.data)
        }).catch((e)=>{  
          console.log(e)
        });
        axios.get(`${url.USERS}`, Config).then((r)=>{ 
          setAssigns(r.data)
        }).catch((e)=>{  
          console.log(e);
        });
        axios.get(`${url.TERRITORIES}`, Config).then((r)=>{ 
          setAreas(r.data);
        }).catch((e)=>{  
          console.log(e);
        });
        axios.get(`${url.MESSAGES}`, Config).then((r)=>{
          setlanguages(r.data)
        }).catch((e)=>{
          console.log(e)
        })
        axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data)}).catch((e)=>console.log(e))
        const obj = JSON.parse(localStorage.getItem("authWTUser"));
        setUserCategory(obj.category)
        setUserId(obj.id)
        setUserName(obj.username)
        setLogs([{"activity": "Registering", "dateTime": formatDate(new Date), "user": obj.username}])
      }
      const handleFilterData = () =>{
        const data = {
          cid       : be.decryptId(id),
          refno     : "",
          phone     : "",
          area      : "",
          category  : "",
          status    : "",
          staff     : "",
          mine      : "",
          dept      : "",
          handler   : "",
          startDate : "",
          endDate   : "",
        }
  
        setIsLoading(true)
        axios.post(`${url.COMPLAINTFILTER}`, JSON.stringify(data), Config).then((r)=>{ 
            setAssignedId(r.data[0].assignedBy)
            setRefNo(r.data[0].refno)
            setName(r.data[0].name)
            setPhone(r.data[0].phone)
            setEmail(r.data[0].email)
            setAccount(r.data[0].account)
            handleCheckAcc(r.data[0].account)
            setAddress(r.data[0].address)
            setArea(r.data[0].areaId)
            setCategory(r.data[0].typeId)
            setLang(r.data[0].lang)
            setDetails(r.data[0].message)
            setStatus(r.data[0].status)
            setDateTimeRegistered(r.data[0].dateTime)
            if(localStorage.getItem("authWTUser")){
              const objs = JSON.parse(localStorage.getItem("authWTUser"));
              if(r.data[0].handlerDeptId == objs.dept){
                setSameDept(true)
              }
            }
            
            if(r.data[0].status != 'Open'){
                setHandler(r.data[0].handlerId)
                setHandlerDept(r.data[0].handlerDeptId)
                setDateTimeAssigned(r.data[0].assignDateTime)
                setResponseTime(r.data[0].responseTime + ' minute(s)')
            }
            if(r.data[0].status == 'Closed'){
                setClosedOn(r.data[0].closeDateTime)
                setWorkDone(r.data[0].workDone)
                setRecommendations(r.data[0].recommendations)
                setCorrectionTime(r.data[0].correctionTime + ' minute(s)')
                setTotalCorrectionTime(r.data[0].totalResolutionTime + ' minute(s)')
            }
            axios.get(`${url.ATTACHDOCUMENT}?${r.data[0].id}`, Config).then((rr)=>{
              setUploadedFiles(rr.data)
            }).catch((er)=>{
              console.log(er)
            })
            axios.get(`${url.USERLOGS}?${r.data[0].id}`, Config).then((rr)=>{
              setLogs(rr.data)
            }).catch((er)=>{
              console.log(er)
            })
          setIsLoading(false)
        }).catch((e)=>{  
          console.log(e); 
          setIsLoading(false)
        });
      }
      useEffect(() => {
        fetchData();
      },[]);
      const handleAssignToAnother = () =>{
        tog_assign();
      }
      const handleReassign = () =>{
        if(handlerDept.trim() == ""){
            toastr.error("Select department to handle complaint")
          }else if(handler.trim() == ""){
            toastr.error("Select staff to handle complaint")
          }else{
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            const data = {
                id : be.decryptId(id),
                status : 'Re-Assigned',
                dept   : nHandlerDept,
                handler: nHandler,
                userId : obj.id
            }
            setIsLoading(true)
            axios.post(url.ASSIGNCOMPLAINT, JSON.stringify(data), Config).then((r)=>{
              if(r.data.status == '1'){
                toastr.success(r.data.message)
                fetchData();
                tog_assign()
                //history.push('/Customer-Complaints')
              }else{
                toastr.error(r.data.message)
              }
              setIsLoading(false)
            }).catch((e)=>{
              console.log(e)
              setIsLoading(false)
            })
            
          }
      }
      const handleUpdateComplaint = () =>{
        if(name.trim().length < 3){
          toastr.error("Enter complainant's name")
        }else if((phone.trim().length < 10) ){
          toastr.error("Enter valid complainant's phone number")
        }else if(!be.fno(phone)){
          toastr.error("Enter valid complainant's phone number in format +252631234567")
        }else if(address.trim().length < 5){
          toastr.error("Enter complainant's address")
        }else if(lang.length < 3){
          toastr.error("Specify communication language")
        }else if(category.trim() == ""){
          toastr.error("Specify complaint category")
        }else{
          const obj = JSON.parse(localStorage.getItem("authWTUser"));

          const  data = {
            id      : be.decryptId(id),
            name    : name,
            phone   : phone,
            email   : email,
            account : account.toUpperCase().replace(/\s+/g, ''),
            address : address,
            area    : area,
            type    : category,
            message : details,
            status  : status,
            lang    : lang,
            userId  : obj.id,
            action  : "edit"
            }
          setIsLoading(true)
          axios.post(url.COMPLAINTS, JSON.stringify(data), Config).then((r)=>{
            if(r.data.status == '1'){
              toastr.success(r.data.message)
              history.push("/Customer-Complaint-Details/"+id)
            }else{
              toastr.error(r.data.message)
            }
            setIsLoading(false)
          }).catch((e)=>{
            console.log(e)
            setIsLoading(false)
          })
        
        }
        
      }
      const handleHandlerChange = (e) =>{
        setHandlerDept(e.target.value)
        setIsLoading(true)
        axios.get(`${url.USERS}?dept?${e.target.value}`, Config).then((r)=>{ 
            setAssigns(r.data);
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e);
            setIsLoading(false)
          });
    }
    const handleDownload = (f)=>{
      const urlx = url.APACHE_URL+"/attach/"+ f.file
      axios({
          url: urlx,
          method: 'GET',
          responseType: 'blob',
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', f.file);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error('Error downloading the file:', error);
        });
    }
    const removeFile = (f) =>{
      const data = {
        action:"delete",
        fId: f.id,
        fName: f.file
      }
      setIsLoading(true)
      axios.post(url.ATTACHDOCUMENT, JSON.stringify(data), Config).then((rf)=>{
        toastr.success(rf.data.message)
        fetchData()
      }).catch((ef)=>{ 
          console.log(ef)
          setIsLoading(false)
      })
    }
    const handleSubmitFiles = () =>{
      if(selectedFile.length > 0){
        selectedFile.forEach((f)=>{
          const reader = new FileReader();
          reader.readAsDataURL(f);
          reader.onloadend = () => {
              const base64Data = reader.result;
              const fileName = f.name;
              const fileExtension = fileName.split('.').pop();
              const fileData = {
                  action:"add",
                  cId: be.decryptId(id),
                  FileName:fileName,
                  FileExtension: fileExtension,
                  fileContentType:be.getContentTypeFromBase64(base64Data),
                  FileContentsBase64:base64Data.split(',')[1]
              }

              setIsLoading(true)
              axios.post(url.ATTACHDOCUMENT, JSON.stringify(fileData), Config).then((rf)=>{
                toastr.success(rf.data.message)
                tog_file()
                fetchData()
              }).catch((ef)=>{ 
                  console.log(ef)
                  setIsLoading(false)
              })
              
          }
        })
      }
    }
    const nHandleHandlerChange = (e) =>{
        setNHandlerDept(e.target.value)
        setIsLoading(true)
        axios.get(`${url.USERS}?dept?${e.target.value}`, Config).then((r)=>{ 
            setAssigns(r.data);
            setIsLoading(false)
          }).catch((e)=>{  
            console.log(e);
            setIsLoading(false)
          });
    }
    const handleDelete = () =>{
      const obj = JSON.parse(localStorage.getItem("authWTUser"));
      const data = {
        id      : be.decryptId(id),
        userId  : obj.id
      }
      setIsLoading(true)
      axios.post(url.DELETECOMPLAINT, JSON.stringify(data), Config).then((r)=>{
        if(r.data.status == '1'){
          toastr.success(r.data.message)
          history.push('/Customer-Complaints')
        }else{
          toastr.error(r.data.message)
        }
        setIsLoading(false)
      }).catch((e)=>{
        console.log(e)
        setIsLoading(false)
      })
    }
    const handleAssign = () =>{
      if(handlerDept.trim() == ""){
        toastr.error("Select department to handle complaint")
      }else if(handler.trim() == ""){
        toastr.error("Select staff to handle complaint")
      }else{
        const obj = JSON.parse(localStorage.getItem("authWTUser"));
        const data = {
            id : be.decryptId(id),
            status : 'Assigned',
            dept   : handlerDept,
            handler: handler,
            userId : obj.id
        }
        setIsLoading(true)
        axios.post(url.ASSIGNCOMPLAINT, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == '1'){
            toastr.success(r.data.message)
            history.push('/Customer-Complaints')
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false)
        }).catch((e)=>{
          console.log(e)
          setIsLoading(false)
        })
        
      }
    }
    const handleClose = () =>{
      if(workDone.trim() == ""){
        toastr.warning("any brief description of what was done?")
      }else{
        const obj = JSON.parse(localStorage.getItem("authWTUser"));
        const data = {
            id    : be.decryptId(id),
            work  : workDone,
            rec   : recommendations,
            userId: obj.id
        }
        setIsLoading(true)
        axios.post(url.CLOSECOMPLAINT, JSON.stringify(data), Config).then((r)=>{
          if(r.data.status == '1'){
            toastr.success(r.data.message)
            history.push('/Customer-Complaints')
          }else{
            toastr.error(r.data.message)
          }
          setIsLoading(false)
        }).catch((e)=>{
          console.log(e)
          setIsLoading(false)
        })
      
      }
    }

   
    return (
        <>
        <LoadingOverlay
            active={isLoading}
            spinner={<BounceLoader />}
            text='Please wait...' >
            <div className="page-content">
                <MetaTags>
                <title>Customer Complaint Details | {url.COMPANY}</title>
                </MetaTags>
                <Container fluid={true}>

                               

                    <div>
                        <Row>
                        <Col  xl={12}>{(status == 'Open')?(<Alert color='danger'>Reference number: {refno}, &nbsp; &nbsp;  {status}</Alert>):((status == 'Assigned') || (status == 'Re-Assigned'))?<Alert color='warning'>Reference number: {refno} &nbsp; &nbsp;  {status}</Alert>:<Alert color='success'>Reference number: {refno} &nbsp; &nbsp;   {status}</Alert>}</Col>
                        <Col  xl={9}>

                                <Modal isOpen={modal_assign} toggle={() => { tog_assign(); }}  size="l" centered  backdrop={'static'}  >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Assign Complaint to another handler` }</h5>
                                    <button type="button"  onClick={() => { setmodal_assign(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint Type/category</label>
                                                <select className="form-select" value={category} onChange={(e)=>setCategory(e.target.value)}>
                                                    <option value=""></option>
                                                    {categories.map((c,k)=>(
                                                        <option value={c.id} key={k}>{c.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Department to handle</label>
                                                <select className="form-select" value={nHandlerDept} onChange={(e)=>{nHandleHandlerChange(e)}}>
                                                    <option value={``}></option>
                                                    {deptList.map((x,k)=>(
                                                        <option key={k} value={x.id}>{x.name}</option>
                                                    ))}
                                                </select>
                                                
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Handler</label>
                                                <select className="form-select" value={nHandler} onChange={(e)=>setNHandler(e.target.value)}>
                                                <option value={``}></option>
                                                {assigns.map((a,k)=>(
                                                    <option key={k} value={a.id}>{a.name} - {a.deptName}</option>
                                                ))}
                                                </select>
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  
                                  <div className="modal-footer">
                                  {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                      : ( <Button  type="button" color="primary" className="btn" onClick={handleReassign}  >Assign...</Button> )
                                  }</div>
                                </Modal>
                                <Modal isOpen={modal_file} toggle={() => { tog_file()  }} size="l" centered backdrop={'static'} >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `File(s)` }</h5>
                                    <button type="button"
                                      onClick={() => { setmodal_file(false); }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row >
                                    <Col xl={12}>
                                    <div className="mb-3">
                                            <label htmlFor="floatingnameInput">Attach Files</label>
                                            <input type="file" multiple className="form-control"  onChange={(e)=>setSelectedFile(Array.from(e.target.files))}   />
                                        </div>
                                    </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer">
                                  {isLoading?`Please wait...`:(<>
                                    <button onClick={() => {  tog_file() }} className="btn btn-danger" data-dismiss="modal">Cancel</button>
                                    <button className="btn btn-success" onClick={handleSubmitFiles}>Add file(s)...</button>
                                    </>)}
                                  </div>
                            </Modal>
                        
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">Customer Complaint Details</h5>
                                <CardBody>
                                    <Row>
                                        
                                    <Col md={4}>
                                            <div className="mb-3">
                                                <label>{`Complainant's Name`}</label>
                                                <input type='text' className="form-control" value={name} onChange={(e)=>setName(e.target.value)} disabled={(status == 'Closed')?true:false} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Email</label>
                                                <input type='email' className="form-control" value={email} onChange={(e)=>setEmail(e.target.value)} disabled={(status == 'Closed')?true:false} />
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Phone number </label>
                                                <input type='text' className="form-control" value={phone} placeholder='+252637951277' onChange={(e)=>setPhone(e.target.value)} disabled={(status == 'Closed')?true:false}/>
                                            </div>
                                        </Col>
                                        
                                        
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>District</label>
                                                <select className="form-select" value={area} onChange={(e)=>setArea(e.target.value)} disabled={(status == 'Closed')?true:false}>
                                                <option value=""></option>
                                                    {areas.map((c,k)=>(
                                                        <option value={c.id} key={k}>{c.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Address</label>
                                                <input type='text' className="form-control" value={address} onChange={(e)=>setAddress(e.target.value)} disabled={(status == 'Closed')?true:false}/>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Supply No</label>
                                                <input type='text' className="form-control" value={account} onChange={(e)=>{setAccount(e.target.value); handleCheckAcc(e.target.value)}} disabled={(status == 'Closed')?true:false}/>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="mb-3">
                                                <label>Language</label>
                                                <select className="form-select" value={lang} onChange={(e)=>setLang(e.target.value)} disabled={(status == 'Closed')?true:false}>
                                                      <option value=""></option>
                                                    {languages.map((c,k)=>(
                                                        <option value={c.lang} key={k}>{c.lang}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={8}>
                                            <div className="mb-3">
                                                <label>Complaint Type/category</label>
                                                <select className="form-select" value={category} onChange={(e)=>setCategory(e.target.value)} disabled={(status == 'Closed')?true:false}>
                                                    <option value=""></option>
                                                    {categories.map((c,k)=>(
                                                        <option value={c.id} key={k}>{c.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        
                                        
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Complaint Details</label>
                                                <textarea className="form-control" rows={10} value={details} onChange={(e)=>setDetails(e.target.value)} disabled={(status == 'Closed')?true:false}></textarea>
                                            </div>
                                        </Col>
                                        
                                        {((status == 'Open') || (status == 'Assigned')|| (status == 'Re-Assigned') || (status == 'Closed')) && (
                                            <>
                                            
                                            <Col sm={12}>
                                                <h5 className="text-primary">Assign </h5>
                                                <hr/>
                                            </Col>
                                          
                                            <Row>
                                            <Col md={4}>
                                                    <div className="mb-3">
                                                        <label>Registered on</label>
                                                        <input type='text' className="form-control" defaultValue={dateTimeRegistered} disabled={true}/>
                                                    </div>
                                            </Col>
                                            {(status != 'Open') && (
                                                <Col md={8}>
                                                    <div className="mb-3">
                                                        <label>Assigned on</label>
                                                        <input type='text' className="form-control" defaultValue={dateTimeAssigned} disabled={true}/>
                                                    </div>
                                                </Col>
                                                
                                            )}
                                            </Row>
                                            <Row>
                                            <Col md={4}>
                                                <div className="mb-3">
                                                    <label>Department to handle</label>
                                                    <select className="form-select" value={handlerDept} onChange={(e)=>{handleHandlerChange(e)}} disabled={(status == 'Open')?false:true}>
                                                        <option value={``}></option>
                                                        {deptList.map((x,k)=>(
                                                            <option key={k} value={x.id}>{x.name}</option>
                                                        ))}
                                                    </select>
                                                    
                                                </div>
                                            </Col>
                                            <Col md={8}>
                                                <div className="mb-3">
                                                    <label>Handler</label>
                                                    <select className="form-select" disabled={(status == 'Open')?false:true} value={handler} onChange={(e)=>setHandler(e.target.value)}>
                                                    <option value={``}></option>
                                                    {assigns.map((a,k)=>(
                                                        <option key={k} value={a.id}>{a.name} - {a.deptName}</option>
                                                    ))}
                                                    </select>
                                                </div>
                                            </Col>
                                           
                                            </Row>
                                            </>
                                        )}
                                       
                                        {((status == 'Closed') || (status == 'Assigned') || (status == 'Re-Assigned')) && (
                                            <>
                                            
                                            <Col sm={12}>
                                                <h5 className="text-primary">Close off complaint </h5>
                                                <hr/>
                                            </Col>
                                            {
                                            (status == 'Closed') && (
                                              <>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <label>Closed on</label>
                                                        <input type='text' className="form-control" defaultValue={closedOn} disabled={true}/>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <label>Response time</label>
                                                        <input type='text' className="form-control" defaultValue={responseTime} disabled={true}/>
                                                    </div>
                                                </Col>
                                                <Col md={4}>
                                                    <div className="mb-3">
                                                        <label>Resolution time</label>
                                                        <input type='text' className="form-control" defaultValue={correctionTime} disabled={true}/>
                                                    </div>
                                                </Col>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <label>Total Resolution time</label>
                                                        <input type='text' className="form-control" defaultValue={totalCorrectionTime} disabled={true}/>
                                                    </div>
                                                </Col>
                                                </>
                                            )
                                        }
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <label>Brief description of work done</label>
                                                    <textarea className="form-control" value={workDone} disabled={(status == 'Closed')?true:false} onChange={(e)=>setWorkDone(e.target.value)}/>
                                                </div>
                                            </Col>
                                            <Col md={12}>
                                                <div className="mb-3">
                                                    <label>Recommendations</label>
                                                    <textarea className="form-control" disabled={(status == 'Closed')?true:false} value={recommendations} onChange={(e)=>setRecommendations(e.target.value)}/>
                                                </div>
                                            </Col>
                                            </>
                                        )}
                                       
                                     
                                    </Row>
                                  
                                    

                        
                                    <Row>
                             
                                        <Col>
                                        <div className="modal-footer justify-content-center">
{(status != 'Closed') && (['COMPLAINT MANAGER','CUSTOMER SUPPORT REPRESENTATIVE'].includes(userCategory)) && ( ( <button type="button" className="btn btn-success" onClick={handleUpdateComplaint}>Update complaint details...</button> ) )}
{(status == 'Open') && (['ADMINISTRATOR','COMPLAINT MANAGER','CUSTOMER SUPPORT REPRESENTATIVE'].includes(userCategory)) && ( (<><button type="button" className="btn btn-danger" onClick={handleDelete}>Delete this complaint...</button><button type="button" className="btn btn-warning" onClick={handleAssign}>Assign to Staff/Handler...</button></>))}
{((status == 'Assigned') || (status == 'Re-Assigned')) && (['COMPLAINT MANAGER'].includes(userCategory)) && ((<><button type="button" className="btn btn-warning" onClick={handleAssignToAnother}>Assign to a different Staff/Handler...</button></>) )}
{((status == 'Assigned') || (status == 'Re-Assigned')) && sameDept && ((<><button type="button" className="btn btn-danger" onClick={handleClose}>Close off this complaint...</button> </>) )}
                                  </div>
                                        </Col>
                                    </Row>
                                    </CardBody>
                            </Card>
                            </Col>
                            <Col xl={3}>
                            <Card>
                            <h6 className="card-header bg-transparent border-bottom text-uppercase">{distance}</h6>
                                
                                            <MapContainer center={center} zoom={4} ref={mapRef} style={{ height: '400px', width: '100%' }}>
                                            <LayersControl position="topright">
                                              <LayersControl.BaseLayer  name="Satellite">
                                                <TileLayer
                                                  attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                                                  url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                                                  id="mapbox/satellite-v9" 
                                                  accessToken={process.env.REACT_APP_APIKEY}
                                                />
                                              </LayersControl.BaseLayer>
                                              <LayersControl.BaseLayer checked name="Street">
                                                <TileLayer
                                                    attribution='&copy; <a href="https://www.mapbox.com/">Mapbox</a>'
                                                    url="https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}"
                                                    id="mapbox/streets-v11" 
                                                    accessToken={process.env.REACT_APP_APIKEY}
                                                  />
                                              </LayersControl.BaseLayer>
                                            </LayersControl>
                                              {lat && lng && <Marker position={[lat, lng]} icon={redPoint}><Tooltip><strong>{account}</strong><br/>{lat}<br/>{lng}</Tooltip></Marker>}
                                              <Polyline pathOptions={{ color: 'red' }} positions={routeCoordinates} />
                                            </MapContainer>
                                          
                                </Card>
                           
                                <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Messages</h6>
                                    <CardBody>
                              
                                        <Row>
                                            <Col md={12}>
                                              <ChantBox status={status} handlerId={handler} assignedBy={assignedId} cId={be.decryptId(id)}/>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Files</h6>
                                    <CardBody>
                                        <Row className="justify-content-center">
                                            <Col md={12}>
                                      {(loadingFiles ? (
                                        <>
                                        <div className="text-center">
                                                    <div className="mb-4">
                                                    </div>
                                                    <div>
                                                    <h5>Loading files ...</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                        </>
                                    ): ((uploadedFiles.length > 0)?(
                                        <div className="table">
                                                <Table className="table table-striped table-sm mb-4">
                                                    
                                                    <tbody>
                                      	                {uploadedFiles.map((a,k)=>(
                                                            <tr key={k}>
                                                              <td style={{ verticalAlign: 'middle', textAlign: 'right' }}> <>
                                                                    <div className="d-flex gap-3">
                                                                    {(status != 'Closed') && (
                                                                        <Link
                                                                        to="#"
                                                                        className="text-danger"
                                                                        onClick={() => removeFile(uploadedFiles[k])}
                                                                        >
                                                                        <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                        <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                            Delete
                                                                        </UncontrolledTooltip>
                                                                        </Link>
                                                                        )}
                                                                    </div>
                                                               
                                                                    </></td>
                                                                
                                                                <td style={{ verticalAlign: 'middle' }}>
                                                                
                                                                <Link to="#" onClick={()=>handleDownload(uploadedFiles[k])}>{a.file}</Link></td>
                                                                
                                                               
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                                </div>
                                            ):(
                                                <div className="text-center">
                                                    <div className="mb-4">
                                                    <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                                    </div>
                                                    <div>
                                                    <h5>No file attached</h5>
                                                    <p className="text-muted">
                                                            
                                                    </p>
                                                    </div>
                                                </div>
                                            )))}
                                            </Col>
                                            {(status != "Closed") && (
                                            <div className="col-auto">
                                              <Button
                                                color="primary" 
                                                className="chat-send w-md btn-rounded "
                                                onClick={() =>{ tog_file() }}
                                              >
                                                <span className="d-none d-sm-inline-block me-2">Add file</span>{" "}
                                                <i className="mdi mdi-file" />
                                              </Button>
                                            </div>
                                            )}
                                        </Row>
                                    </CardBody>
                                </Card>
                                <Card>
                                <h6 className="card-header bg-transparent border-bottom text-uppercase">Logs</h6>
                                    <CardBody>
                              
                                        <Row>
                                            <Col md={12}>
                                            <div>
                                                <ul className="verti-timeline list-unstyled">
                                                {logs.map((l,k)=>(
                                                    <li key={k} className="event-list">
                                                    <div className="event-timeline-dot">
                                                        <i className="bx bx-right-arrow-circle" />
                                                    </div>
                                                    <div className="d-flex">
                                                        <div className="me-3">
                                                        <i className="bx bx-copy-alt h2 text-primary" />
                                                        </div>
                                                        <div className="flex-grow-1">
                                                        <div>
                                                            <h5 className="font-size-14">{l.activity}</h5>
                                                            <p className="text-muted">
                                                            {l.dateTime}<br/>{l.user}
                                                            </p>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </li>
                                                ))}
                        
                                                </ul>
                                                </div>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                           
                        </Row>
                    </div>
                </Container>  
            </div>
            </LoadingOverlay>
        </>
    );
}

export default ComplaintDetails;